import { Button } from "@mui/material";
import { ReactComponent as FontMinus } from "../../assets/icons/FontMinus.svg";
import { ReactComponent as FontPlus } from "../../assets/icons/FontPlus.svg";
import { ReactComponent as FontRefresh } from "../../assets/icons/FontRefresh.svg";
import { ReactComponent as StopIcon } from "../../assets/icons/Stop.svg";
import { ReactComponent as PlayIcon } from "../../assets/icons/play.svg";
import { ReactComponent as PauseIcon } from "../../assets/icons/pause.svg";

interface PlusMinusButtonProps {
  handlePlus: () => void;
  handleMinus: () => void;
  handleClickScroll: () => void;
  scroll: string;
  icon: "play" | "pause" | "refresh";
  orientation?: "horizontal" | "vertical";
}

export const PlusMinusButton = ({
  handlePlus,
  handleMinus,
  handleClickScroll,
  scroll,
  icon,
  orientation = "horizontal",
}: PlusMinusButtonProps) => {
  return (
    <>
      {orientation === "horizontal" ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#1F1F1F",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              // gap: "10px",
            }}
          >
            <Button
              onClick={handleMinus}
              sx={{
                width: 40, // set fixed width
                minWidth: 40, // avoid MUI default minWidth
                height: 40, // optional height
                padding: 0, // optional
              }}
            >
              <FontMinus />
            </Button>{" "}
            <Button
              onClick={() => {
                handleClickScroll();
                // console.log("scroll", scroll);
                // scroll === "0x" ? handleClickScroll(1) : handleClickScroll(0);
              }}
              sx={{
                width: 40, // set fixed width
                minWidth: 40, // avoid MUI default minWidth
                height: 40, // optional height
                padding: 0, // optional
              }}
            >
              {/* <StopIcon /> */}

              {icon === "refresh" ? (
                <FontRefresh />
              ) : (icon === "play" || icon === "pause") && scroll === "0x" ? (
                <PlayIcon style={{ width: "35px", height: "35px" }} />
              ) : (
                <StopIcon />
              )}
            </Button>
            <Button
              onClick={handlePlus}
              sx={{
                width: 40, // set fixed width
                minWidth: 40, // avoid MUI default minWidth
                height: 40, // optional height
                padding: 0, // optional
              }}
            >
              <FontPlus />
            </Button>
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // backgroundColor: "#1F1F1F",
            backgroundColor: "transparent", // fully transparent
            // border: "1px solid rgba(255, 255, 255, 0.6)", // white semi-transparent border
            // borderRadius: "10px",
            padding: "5px",
            // backdropFilter: "blur(6px)",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column", // vertical
              alignItems: "center",
              justifyContent: "center",
              // gap: "1px",
            }}
          >
            <Button
              onClick={handlePlus}
              sx={{
                width: 40,
                minWidth: 40,
                height: 40,
                padding: 0,
              }}
            >
              <FontPlus />
            </Button>

            <p>{scroll}</p>
            <Button
              onClick={handleMinus}
              sx={{
                width: 40,
                minWidth: 40,
                height: 40,
                padding: 0,
              }}
            >
              <FontMinus />
            </Button>
          </div>
        </div>
      )}
    </>
  );
};
